//
import axios from 'axios'

/**
 *
 */
const fetchAll = async () => {
    //
    try {
        //
        const route = process.env.VUE_APP_API_ROUTE.concat(
            '/hr_employee?get_all_results=true'
        )
        const response = await axios.get(route)
        //
        return response.data.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchAll
